import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '~environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReviewsService {
  constructor(private readonly translateService: TranslateService) {}

  public getReviewsPageUrl(
    activityId: string,
    organizationId?: string,
    timeslotId?: string
  ): string | null {
    const { currentLang } = this.translateService;

    if (!activityId) {
      return null;
    }

    const url = new URL(
      `${environment.applications.reviews.url}/collect/${currentLang.replace(
        '-',
        '_'
      )}/decathlon/activity/${activityId}`
    );

    if (organizationId) {
      url.searchParams.append(
        'contexts[]',
        `decathlon.activity_organization:${organizationId}`
      );
    }

    if (timeslotId) {
      url.searchParams.append('activitySession', timeslotId);
    }

    return url.href;
  }
}
